import { Text } from '@ui/atoms';
import React from 'react';
import { fdReturnsCalculator } from '@components/Products/FixedDeposits/utils/helper';

const CalculatorHeader = () => (
    <div className="flex flex-col items-center gap-2 pb-8 border-b border-gray-300 max-w-[415px] mx-auto md:max-w-none w-full">
        <Text
            content={fdReturnsCalculator.title}
            className="text-gray-800 p3-semibold md:h3-semibold"
            htmlTag="h2"
        />
        <Text
            content={fdReturnsCalculator.description}
            className="text-center text-gray-500 p5-regular md:text-left"
            htmlTag="p"
        />
    </div>
);

export default CalculatorHeader;
